<template>
  <div class="effect-wrap">
    <div class="header-wrap">
      <div class="header-line" style="border-bottom: 1px dashed rgba(0, 0, 0, 0.2)">
        <el-date-picker
          class="data-range"
          v-model="filterData.time"
          type="daterange"
          range-separator="→"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 240px"
          value-format="yyyyMMdd"
          :clearable="false"
        >
        </el-date-picker>
        <el-select style="width: 160px; margin-left: 24px" v-model="filterData.timeDemission">
          <el-option label="小时" value="0"> </el-option>
          <el-option label="天" value="1"> </el-option>
          <el-option label="合计" value="2"> </el-option>
        </el-select>
        <el-select style="width: 160px; margin-left: 24px" v-model="filterData.dataDemission">
          <el-option label="产品" value="0"> </el-option>
          <el-option label="广告账号" value="1"> </el-option>
          <el-option label="广告组" value="2"> </el-option>
          <el-option label="计划" value="3"> </el-option>
          <el-option label="创意" value="4"> </el-option>
        </el-select>
        <el-button class="submit-btn" style="margin-left: auto" @click="resetFilterData"
          >重置</el-button
        >
        <el-button class="submit-btn" type="primary" @click="clickSearch">查询</el-button>
      </div>
      <div class="header-line">
        <el-select style="width: 240px" v-model="filterData.pkg" placeholder="选择产品" filterable>
          <el-option label="全部产品" :value="-1"> </el-option>
          <el-option
            v-for="item of appList"
            :key="item.package_name"
            :label="item.app_name + '（' + item.package_name + '）'"
            :value="item.package_name"
          >
          </el-option>
        </el-select>
        <el-select
          style="width: 160px; margin-left: 24px"
          class="multiple-select"
          v-model="filterData.advertiserId"
          placeholder="全部投放账户"
          multiple
          collapse-tags
        >
          <el-option
            v-for="item of advertiserIdList"
            :key="item.advertiserId"
            :label="item.company + ' (' + item.advertiserName + ')'"
            :value="item.advertiserId"
          >
          </el-option>
        </el-select>
        <el-select
          style="width: 160px; margin-left: 24px"
          v-model="filterData.inventory"
          placeholder="选择投放位置"
        >
          <el-option label="全部投放位置" :value="-1"> </el-option>
          <el-option label="今日头条" value="INVENTORY_FEED"></el-option>
          <el-option label="火山小视频" value="INVENTORY_HOTSOON_FEED"></el-option>
          <el-option label="番茄小说" value="INVENTORY_TOMATO_NOVEL"></el-option>
          <el-option label="西瓜视频" value="INVENTORY_VIDEO_FEED"></el-option>
          <el-option label="通投智选" value="INVENTORY_UNIVERSAL"></el-option>
          <el-option label="抖音" value="INVENTORY_AWEME_FEED"></el-option>
          <el-option label="穿山甲" value="INVENTORY_UNION_SLOT"></el-option>
          <el-option label="ohayoo精品游戏" value="UNION_BOUTIQUE_GAME"></el-option>
        </el-select>
      </div>
    </div>
    <div class="table-wrap">
      <div class="table-header">
        <span class="header-text">共 {{ pageData.total }} 条数据</span>
      </div>
      <div class="data-talbe">
        <el-table
          :data="dataList"
          style="width: 100%"
          v-loading="loading"
          :max-height="tableMaxHeight"
        >
          <el-table-column
            v-for="item of colData"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getAdvertiserInfo, effectAnalysis } from "@/api/report.js";
import { getCommonProductList } from "@/api/api.js";
export default {
  name: "effectAnalysis",
  data() {
    return {
      appList: [],
      advertiserIdList: [],
      dataList: [],
      colData: [],
      loading: false,
      filterData: {
        pkg: -1,
        advertiserId: [],
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
        timeDemission: "0",
        dataDemission: "0",
        inventory: -1,
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableMaxHeight: window.innerHeight - 345,
    };
  },
  mounted() {
    this.initSelectOptions();
    this.clickSearch();
  },
  methods: {
    initSelectOptions() {
      getCommonProductList({
        platType: 1,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getAdvertiserInfo().then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
    },
    generateCols() {
      let cols = [
        { label: "时间", value: "stat_datetime", width: "100" },
        { label: "产品", value: "app_name", width: "100" },
        { label: "花费", value: "cost", width: "100" },
        { label: "展示", value: "show_cnt", width: "100" },
        { label: "千次展示成本", value: "avg_show_cost", width: "100" },
        { label: "点击", value: "click_cnt", width: "100" },
        { label: "点击率", value: "ctr", width: "100" },
        { label: "转化", value: "convert_cnt", width: "100" },
        { label: "转化成本", value: "convert_cost", width: "100" },
      ];
      let adCount = { label: "广告账号", value: "advertiser_id", width: "100" };
      let adGroup = { label: "广告组", value: "campaign_name", width: "100" };
      let adPlan = { label: "广告计划", value: "ad_name", width: "100" };
      let adCreate = { label: "广告创意", value: "creative_id", width: "100" };
      switch (this.filterData.dataDemission) {
        case "0":
          break;
        case "1":
          cols.splice(1, 0, adCount);
          break;
        case "2":
          cols.splice(1, 0, adCount, adGroup);
          break;
        case "3":
          cols.splice(1, 0, adCount, adPlan);
          break;
        case "4":
          cols.splice(1, 0, adCount, adPlan, adCreate);
          break;
        default:
      }
      this.colData = cols;
    },
    formatData() {
      let parmas = {
        page: this.pageData.page,
        size: this.pageData.size,
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData.join());
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    searchData() {
      let parmas = this.formatData();
      this.loading = true;
      effectAnalysis(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.generateCols();
          this.pageData.total = res.totalCount;
          this.dataList = res.advertiserDatas.map((item) => {
            item.cost = item.cost.toFixed(2);
            item.convert_cost = item.convert_cost.toFixed(2);
            item.ctr = (item.ctr * 100).toFixed(2) + "%";
            return item;
          });
        }
      });
    },
    clickSearch() {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData();
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    resetFilterData() {
      this.filterData.pkg = -1;
      this.filterData.advertiserId = [];
      this.filterData.time = [
        moment().subtract(7, "days").format("YYYYMMDD"),
        moment().subtract(1, "days").format("YYYYMMDD"),
      ];
      this.filterData.timeDemission = "0";
      this.filterData.dataDemission = "0";
      this.filterData.inventory = -1;
    },
  },
};
</script>

<style lang="less" scoped>
.effect-wrap {
  padding: 16px;
  box-sizing: border-box;
  .header-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 0 24px;
    .header-line {
      display: flex;
      align-items: center;
      padding: 16px 0;
      .data-range {
        position: relative;
        /deep/.el-range__icon {
          position: absolute;
          right: 6px;
          top: 0px;
        }
        /deep/.el-range-separator {
          line-height: 24px;
          color: rgba(0, 0, 0, 0.25);
        }
      }
      .submit-btn {
        padding: 0 20px;
      }
      .multiple-select {
        /deep/ .el-tag.el-tag--info:first-child {
          max-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    margin-top: 16px;
    padding: 16px 24px;
    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      .header-text {
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 14px;
      }
    }
    .data-talbe {
      width: calc(100vw - 262px);
    }
  }
}
</style>
